import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsPhonePolishValidatorDirective } from './is-phone-polish-validator.directive';

@NgModule({
  declarations: [IsPhonePolishValidatorDirective],
  imports: [CommonModule],
  exports: [IsPhonePolishValidatorDirective],
})
export class IsPhonePolishValidatorModule {}
